
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import TipsPopup from '@/components/tipsPopup/index.vue'
import {
  getActivityTemplateList,
  delActivityTemplate
} from '@/api/marketActivity'
import { periodTypeList } from './../index'
import { handleFill } from '@/utils/util'

@Component({
  components: { TipsPopup }
})
class SelectTemplate extends Vue {
  @Getter companyId!: string
  handleFill = handleFill

  activityType: string | number = ''
  activityTypeList = [
    {
      label: '全部分类',
      value: ''
    },
    {
      label: '抽奖活动',
      value: 1
    }
  ]

  // 空白模版对象
  blankCard = {
    activityName: '',
    templateName: '',
    lotteryConfigId: '',
    periodType: 0,
    budgetName: '',
    createTime: ''
  }

  list = [
    {
      title: '抽奖活动',
      activityType: '1',
      cards: []
    }
    // {
    //   title: '预留的其他活动',
    //   cards: []
    // }
  ]

  cardStyleObj = {
    // 空白模版
    0: {
      bgColor: 'linear-gradient(180deg, #DCE1F0 0%, #B2C1EA 100%)',
      tagbdColor: '#D8DEF0',
      color: '#D8DEF0'
    },
    // 只办一次模版
    1: {
      bgColor: 'linear-gradient(180deg, #FAE8D1 0%, #F4CD91 100%)',
      tagbdColor: '#FED18D',
      color: '#FD8305'
    },
    // 每周重复模版
    2: {
      bgColor: 'linear-gradient(180deg, #E1CFF6 0%, #CCB7F7 100%)',
      tagbdColor: '#D0BFFF',
      color: '#7651EA'
    },
    // 每月重复模版
    3: {
      bgColor: 'linear-gradient(180deg, #C7F3D1 0%, #BAE8C9 100%)',
      tagbdColor: '#82E08F',
      color: '#10B135'
    }
  }
  showSettingPopup = false
  settingCard = null // 设置的卡片
  tipsPopupHtmlContent = ''

  @Watch('activityType')
  onActivityTypeChange() {
    this.getList()
  }

  created() {
    this.getList()
  }

  getList() {
    getActivityTemplateList({
      storeId: this.companyId,
      pageIndex: 1,
      pageSize: 999,
      activityType: this.activityType
    }).then((res) => {
      const { records = [] } = res.data
      this.list[0].cards = [this.blankCard, ...records]
    })
  }

  // 获取卡片样式
  getCardStyle(type = 0) {
    return {
      background: `${this.cardStyleObj[type]?.bgColor}`
    }
  }

  // 获取图片源
  getImgSrc(type: number): string {
    const srcMap: Record<string, string> = {
      1: 'messages1.png',
      2: 'messages2.png',
      3: 'messages3.png'
    }
    return require(`@/assets/images/marketActivity/template/${srcMap[type]}`)
  }

  // 获取标签样式
  getTagStyle(type = 0) {
    return {
      color: this.cardStyleObj[type]?.color,
      borderColor: this.cardStyleObj[type]?.tagbdColor
    }
  }

  // 获取周期类型标签
  getPeriodTypeLabel(periodType: number) {
    const item = periodTypeList.find((p) => p.value === Number(periodType))
    return item.label || '--'
  }

  // 选择模板
  onSelectTemplate(lotteryConfigId: string) {
    this.$router.replace({
      path: '/createMarketActivity',
      query: { lotteryConfigId }
    })
  }

  onSettingClick(card: any) {
    this.settingCard = card
    this.showSettingPopup = true
  }

  onSettingPopupClose() {
    this.settingCard = null
    this.showSettingPopup = false
  }

  onDel() {
    if (!this.settingCard?.lotteryConfigId) {
      this.$toast('模板信息不存在')
      return
    }

    this.tipsPopupHtmlContent = `
      <P>此操作将永久删除模板“${this.settingCard.templateName}”，删除后无法恢复。</P>
      <P>确定要删除吗？</P>
    `
    ;(this.$refs.tipsPopupRef as any).showPopup()
  }

  // 确认删除模板
  onTipsConfirm() {
    if (!this.settingCard?.lotteryConfigId) {
      this.$toast('模板信息不存在')
      return
    }

    delActivityTemplate({
      storeId: this.companyId,
      lotteryConfigId: this.settingCard.lotteryConfigId
    })
      .then(() => {
        this.$toast('删除成功')
        // 关闭设置弹窗
        this.onSettingPopupClose()
        // 刷新列表
        this.getList()
      })
      .catch(() => {
        this.$toast(this.settingCard.isDelete === 1 ? '删除失败' : '默认模版不能删除')
      })
  }
}
export default SelectTemplate
